/* eslint-disable */
import moment from 'moment';
import * as DateTimeUtil from '@/utils/datetime';

export function getLatLngFromXY(x, y) {
  return {
    lat: y * Math.pow(10, -6),
    lng: x * Math.pow(10, -6)
  };
}

export function getLatLngFromWaypoint(wp) {
  if (wp != null && wp.x !== undefined && wp.y !== undefined && wp.x != null && wp.y != null) {
    return getLatLngFromXY(wp.x, wp.y);
  }
  return {
    lat: 10.763553,
    lng: 106.671185
  };
}

export function isVehicleRunning(vehicle) {
  return vehicle.waypoint.status > 0 && vehicle.waypoint.kmh >= 5;
}

export function isVehicleIdle(vehicle) {
  return vehicle.waypoint.status > 0 && vehicle.waypoint.kmh < 5;
}

export function isVehicleOffline(vehicle) {
  return vehicle.waypoint.status <= 0;
}

export function getVehicleLimitSpeed(vehicle) {
  return vehicle.maxSpeed != null && vehicle.maxSpeed > 0 ? vehicle.maxSpeed : 999;
}

export function isVehicleOverspeed(vehicle) {
  return isVehicleRunning(vehicle) && vehicle.waypoint.kmh > getVehicleLimitSpeed(vehicle);
}

export function isVehicleDisconnected(vehicle) {
  // let lastTime = moment().diff(DateTimeUtil.convertSecond2010ToDateTime(vehicle.waypoint.time), 'minutes');
  // return (isVehicleIdle(vehicle) && lastTime >= 60) || (isVehicleRunning(vehicle) && lastTime >= 10);
  return !vehicle.waypoint.isConnected
}

export function getVehicleStatus(vehicle) {

  let status = '---';

  if (vehicle.waypoint != null) {

    let lastTimeString = DateTimeUtil.convertSecondToRelativeTime(vehicle.waypoint.time);

    if (isVehicleRunning(vehicle)) {
      status = `Đang chạy ${vehicle.waypoint.kmh} Km/h`;
    }

    if (isVehicleIdle(vehicle)) {
      status = `Dừng ${lastTimeString}`;
    }

    if (isVehicleOffline(vehicle)) {
      status = `Tắt máy ${lastTimeString}`;
    }

    if (isVehicleOverspeed(vehicle)) {
      status = `Đang chạy ${vehicle.waypoint.kmh} Km/h (Quá tốc độ)`;
    }

    if (isVehicleDisconnected(vehicle)) {
      status = `Mất kết nối ${lastTimeString}`;
    }
  }

  return status;
}

export function getVehicleIcon(vehicle) {

  let vehicleType = vehicle.vehicleType === 1 ? 'motor' : 'car';

  let runningVehicle = `static/icons/${vehicleType}/green.png`;
  let stoppedVehicle = `static/icons/${vehicleType}/yellow.png`;
  let offlineVehicle = `static/icons/${vehicleType}/black.png`;
  let overspeedVehicle = `static/icons/${vehicleType}/red.png`;
  let disconnectedVehicle = `static/icons/${vehicleType}/gray.png`;

  let url = disconnectedVehicle;

  if (vehicle.waypoint != null) {

    if (isVehicleRunning(vehicle)) {
      url = runningVehicle;
    }

    if (isVehicleIdle(vehicle)) {
      url = stoppedVehicle;
    }

    if (isVehicleOffline(vehicle)) {
      url = offlineVehicle;
    }

    if (isVehicleOverspeed(vehicle)) {
      url = overspeedVehicle;
    }

    if (isVehicleDisconnected(vehicle)) {
      url = disconnectedVehicle;
    }
  }

  return url;
}

export function getVehicleIconForHistory(vehicle) {

  let vehicleType = vehicle.vehicleType === 1 ? 'motor' : 'car';

  let runningVehicle = `static/icons/${vehicleType}/green.png`;
  let stoppedVehicle = `static/icons/${vehicleType}/yellow.png`;
  let offlineVehicle = `static/icons/${vehicleType}/black.png`;
  let overspeedVehicle = `static/icons/${vehicleType}/red.png`;

  let url = offlineVehicle;

  if (vehicle.waypoint != null) {

    if (isVehicleRunning(vehicle)) {
      url = runningVehicle;
    }

    if (isVehicleIdle(vehicle)) {
      url = stoppedVehicle;
    }

    if (isVehicleOffline(vehicle)) {
      url = offlineVehicle;
    }

    if (isVehicleOverspeed(vehicle)) {
      url = overspeedVehicle;
    }
  }

  return url;
}

// export function getVehicleMarkerIcon(vehicle) {

//   let url = getVehicleIcon(vehicle);

//   let icon = new L.Icon({
//     iconUrl: url,
//     iconSize: [50, 50],
//   });

//   let marker = new L.marker(getLatLngFromWaypoint(vehicle.waypoint), {
//     icon: icon,
//     rotationAngle: vehicle.waypoint.heading,
//     rotationOrigin: 'center center'
//   })
//     .bindTooltip(vehicle.plate, {
//       permanent: true,
//       direction: 'bottom',
//       opacity: 1,
//       offset: [0, 25]
//     });

//   return marker;
// }

// export function getVehicleMarkerIconForHistory(vehicle) {

//   let url = getVehicleIconForHistory(vehicle);

//   let icon = new L.Icon({
//     iconUrl: url,
//     iconSize: [50, 50]
//   });

//   let marker = new L.marker(getLatLngFromWaypoint(vehicle.waypoint), {
//     icon: icon,
//     rotationAngle: vehicle.waypoint.heading,
//     rotationOrigin: 'center center'
//   });

//   return marker;
// }

export function getAddressFromWaypoint(point) {
  let address = 'Không xác định';
  if (point.data) {
    if (point.data.addr !== undefined) {
      address = `${point.data.addr},${point.data.admin}`;
    } else {
      address = point.data.admin;
    }
    address = address.split(',').join(', ');
    point.address = address;
  }
  return address;
}

export function calcDistance (lat1, lon1, lat2, lon2, unit) {
  if (lat1 === lat2 && lon1 === lon2) {
    return 0;
  } else {
    let radlat1 = (Math.PI * lat1) / 180;
    let radlat2 = (Math.PI * lat2) / 180;
    let theta = lon1 - lon2;
    let radtheta = (Math.PI * theta) / 180;
    let dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit === 'K') {
      dist = dist * 1.609344;
    }
    if (unit === 'N') {
      dist = dist * 0.8684;
    }
    return dist;
  }
}

// export const MAP_CONFIG = {
//   zoom: 12,
//   center: L.latLng(10.7589923, 106.67304),
//   mapBox: {
//     attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
//     url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoidHJ1b25nbXYiLCJhIjoiY2pqMW9ldnh6MHVueTNrcGNoZTllNWJmYyJ9.-hB4McZSoCD5zcV_klvR2g',
//     mapId: 'mapbox.streets',
//     accessToken: 'pk.eyJ1IjoidHJ1b25nbXYiLCJhIjoiY2pqMW9ldnh6MHVueTNrcGNoZTllNWJmYyJ9.-hB4McZSoCD5zcV_klvR2g'
//   },
//   OpenStreetMap: {
//     attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
//     url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
//   }
// }

// export function createMapTileLayer(type) {
//   return new L.gridLayer.googleMutant({ type: type })
// }

export const GREEN_POLYLINE_OPTION = {
  color: '#008e15',
  weight: 4,
  opacity: 0.7
}

export const BLUE_POLYLINE_OPTION = {
  color: '#00b3fd',
  weight: 4,
  opacity: 0.7
}

export const RED_POLYLINE_OPTION = {
  color: 'red',
  weight: 4,
  opacity: 1
}

export const FENCE_OPTION = {
  color: '#008e15',
  weight: 1,
  opacity: 0.1
}

export const MY_LOCATION_FENCE_OPTION = {
  color: 'yellow',
  weight: 1,
  opacity: 0.2
}

// export const DEFAULT_MARKER = L.icon({
//   iconUrl: 'static/icons/marker.svg',
//   iconSize: [40, 40],
//   iconAnchor: [20, 40]
// })

// export const DEFAULT_VEHICLE_MARKER = L.icon({
//   iconUrl: 'static/icons/vehiclemarker.png',
//   iconSize: [40, 40],
//   iconAnchor: [20, 40]
// })

// export const MY_LOCATION_MARKER = L.icon({
//   iconUrl: 'static/icons/mylocation.png',
//   iconSize: [24, 24]
// })

// export const STOPPED_MARKER = L.icon({
//   iconUrl: 'static/icons/stoppedmarker.png',
//   iconSize: [40, 40],
//   iconAnchor: [20, 40]
// })



// WEBPACK FOOTER //
// ./src/utils/maputil.js